"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Eye_exports = {};
__export(Eye_exports, {
  default: () => Eye_default
});
module.exports = __toCommonJS(Eye_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m21 12.316.54.263a.6.6 0 0 0 .01-.504l-.55.24Zm-18 0-.55-.241a.6.6 0 0 0 .01.504l.54-.263Zm18 0-.54-.263h.001l-.005.009-.02.04a9.535 9.535 0 0 1-.464.769 11.525 11.525 0 0 1-1.552 1.855C17.024 16.074 14.916 17.4 12 17.4v1.2c3.315 0 5.707-1.516 7.253-3.01a12.726 12.726 0 0 0 1.715-2.052 10.7 10.7 0 0 0 .53-.88l.03-.056.008-.016.002-.005v-.001h.001L21 12.315ZM12 17.4c-2.916 0-5.024-1.326-6.42-2.674a11.524 11.524 0 0 1-1.55-1.856 9.526 9.526 0 0 1-.485-.808l-.004-.009H3.54l-.54.263-.54.263h.001l.001.002.002.005.009.016.028.056c.025.047.06.114.108.197.094.168.235.403.423.683.375.56.942 1.305 1.715 2.051C6.293 17.084 8.685 18.6 12 18.6v-1.2Zm-9-5.084.55.241v-.001l.004-.01.021-.045.09-.184a12.666 12.666 0 0 1 1.937-2.75C7.005 8.06 9.107 6.6 12 6.6V5.4c-3.338 0-5.736 1.696-7.276 3.349a13.863 13.863 0 0 0-2.128 3.023 8.037 8.037 0 0 0-.142.295l-.002.005-.001.002.549.242ZM12 6.6c2.893 0 4.995 1.461 6.398 2.967a12.669 12.669 0 0 1 1.936 2.75 6.492 6.492 0 0 1 .112.229l.004.01v.001l.55-.241.55-.242h-.001v-.002a13.867 13.867 0 0 0-2.273-3.323C17.736 7.096 15.338 5.4 12 5.4v1.2Zm2.4 5.4a2.4 2.4 0 0 1-2.4 2.4v1.2a3.6 3.6 0 0 0 3.6-3.6h-1.2ZM12 14.4A2.4 2.4 0 0 1 9.6 12H8.4a3.6 3.6 0 0 0 3.6 3.6v-1.2ZM9.6 12A2.4 2.4 0 0 1 12 9.6V8.4A3.6 3.6 0 0 0 8.4 12h1.2ZM12 9.6a2.4 2.4 0 0 1 2.4 2.4h1.2A3.6 3.6 0 0 0 12 8.4v1.2Z"
    }
  )
);
const SvgEye = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Eye_default = SvgEye;
